// import React from 'react'

// function SideBarFaq() {

//     const items = [
//         'About Moveonwheels',
//         'Your Trip',
//         'Payments & Refunds',
//         'Your Booking', 
//         'Wallet',
//         'Refer A Friend',
//       ];

//   return (
//       <div className="space-y-3 w-full p-6 height-auto mx-auto">
//       {items.map((item, index) => (
//         <button
//           key={index}
//           className="w-full py-4 bg-gray-100 text-gray-700 text-center rounded-md shadow-sm hover:bg-gray-200 focus:outline-none"
//         >
//           {item}
//         </button>
//       ))}
//     </div>
//   )
// }

// export default SideBarFaq


// import React from 'react';
// import { Link } from 'react-router-dom';

// function SideBarFaq() {
//   const items = [
//     { name: 'About Moveonwheels', path: '/about' },
//     { name: 'Your Trip', path: '/trip' },
//     { name: 'Payments & Refunds', path: '/payment' },
//     { name: 'Your Booking', path: '/your-booking' },
//     { name: 'Wallet', path: '/wallet-faq' },
//     { name: 'Refer A Friend', path: '/refer' },
//   ];

//   return (
//     <div className="space-y-3  w-full p-6 height-auto mx-auto">
//       {items.map((item, index) => (
//         <Link
//           key={index}
//           to={item.path}
//           className="block w-full py-4 bg-gray-100 text-gray-700 text-center rounded-md shadow-sm hover:bg-gray-200 focus:outline-none"
//         >
//           {item.name}
//         </Link>
//       ))}
//     </div>
//   );
// }

// export default SideBarFaq;

// import React from "react";
// import { Link } from "react-router-dom";

// const SideBarFaq = () => {
//   return (
//     <div className=" bg-gray-100 h-screen p-4">
//       <ul className="space-y-4">
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about">About Moveonwheels</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/trip">Your Trip</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/payment">Payments & Refunds</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/your-booking">Your Booking</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/wallet-faq">Wallet</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/refer">Refer A Friend</Link>
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default SideBarFaq;


// import React from "react";
// import { Link } from "react-router-dom";

// const SideBarFaq = () => {
//   return (
//     <div className="bg-gray-100 h-screen p-4">
//       <ul className="space-y-4">
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about">About Moveonwheels</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/trip">Your Trip</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/payment">Payments & Refunds</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/your-booking">Your Booking</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/wallet-faq">Wallet</Link>
//         </li>
//         <li className="text-gray-700 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/refer">Refer A Friend</Link>
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default SideBarFaq;

import React from "react";
import { Link } from "react-router-dom";

const SideBarFaq = () => {
  return (
    <div className=" h-screen p-4">
      <ul className="space-y-4">
        <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg text-center">
          <Link to="/about" className="block w-full h-full">
            About Moveonwheels
          </Link>
        </li>
        <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg text-center">
          <Link to="/about/trip" className="block w-full h-full">
            Your Trip
          </Link>
        </li>
        <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg text-center">
          <Link to="/about/payment" className="block w-full h-full">
            Payments & Refunds
          </Link>
        </li>
        <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg text-center">
          <Link to="/about/your-booking" className="block w-full h-full">
            Your Booking
          </Link>
        </li>
        <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg text-center">
          <Link to="/about/wallet-faq" className="block w-full h-full">
            Wallet
          </Link>
        </li>
        <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg text-center">
          <Link to="/about/refer" className="block w-full h-full">
            Refer A Friend
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SideBarFaq;
